import { 
    CREATEHOSPITALEMESSAGE, 
    CREATEHOSPITALESENDEMAIL, 
    CREATEHOSPITALESENDMESSAGE, 
    DELETEHOSPITALEMESSAGE, 
    DELETEHOSPITALESENDEMAIL, 
    DELETEHOSPITALESENDMESSAGE, 
    GETHOSPITALEMESSAGE, 
    GETHOSPITALESENDEMAIL, 
    GETHOSPITALESENDMESSAGE, 
    UPDATEHOSPITALEMESSAGE, 
    UPDATEHOSPITALESENDEMAIL, 
    UPDATEHOSPITALESENDMESSAGE
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEMESSAGE:
            return {
                ...state,
                messagelistSaveStatus: action.payload.success,
            }
        case GETHOSPITALEMESSAGE:
                return {
                        ...state,
                        messageList: action.payload.data,
                        }
        case UPDATEHOSPITALEMESSAGE:
                return {
                        ...state,
                        messageUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALEMESSAGE:
                 return {
                     ...state,
                     messageDeleteStatus: action.payload.success,
                        }
        case CREATEHOSPITALESENDMESSAGE:
            return {
                ...state,
                sendmessagelistSaveStatus: action.payload.success,
            }
        case GETHOSPITALESENDMESSAGE:
                return {
                        ...state,
                        sendmessageList: action.payload.data,
                        }
        case UPDATEHOSPITALESENDMESSAGE:
                return {
                        ...state,
                        sendmessageUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALESENDMESSAGE:
                 return {
                     ...state,
                     sendmessageDeleteStatus: action.payload.success,
                        }
        case CREATEHOSPITALESENDEMAIL:
            return {
                ...state,
                sendemaillistSaveStatus: action.payload.success,
            }
        case GETHOSPITALESENDEMAIL:
                return {
                        ...state,
                        sendemailList: action.payload.data,
                        }
        case UPDATEHOSPITALESENDEMAIL:
                return {
                        ...state,
                        sendemailUpdateStatus: action.payload.success,
                        }   

        case DELETEHOSPITALESENDEMAIL:
                 return {
                     ...state,
                     sendemailDeleteStatus: action.payload.success,
                        }
                        default:
                            return state
                             }
                         }